import React, { useEffect, useState } from 'react';
import { getSunrise, getSunset } from 'sunrise-sunset-js';

export const ThemeContext = React.createContext({
  name: 'light',
  updateTheme: () => { },
});
const melbCoordinates = { x: -37.8136, y: 144.9631 };

export const ThemeProvider = ({ children }) => {
  const [yesterdayEvening] = React.useState(new Date());
  const [melbSunset, setMelbSunset] = React.useState(null)
  const [melbSunrise, setMelbSunrise] = React.useState(null)
  const [todayEvening] = useState(t => {
    t = new Date();
    t.setHours(18, 30)
    return t;
  });
  // const [todayMorning] = useState(t => {
  //   t = new Date()
  //   t.setHours(6, 30)
  //   return t;
  // });
  React.useEffect(() => {
    if (yesterdayEvening && todayEvening) {
      yesterdayEvening.setDate(todayEvening.getDate() - 1);
      yesterdayEvening.setHours(18, 30);

      setMelbSunset(getSunset(melbCoordinates.x, melbCoordinates.y, new Date()))
      setMelbSunrise(getSunrise(melbCoordinates.x, melbCoordinates.y, yesterdayEvening))
    }
  }, [todayEvening, yesterdayEvening])

  const [theme, setTheme] = useState('light');

  useEffect(() => {
    let melbTime = new Date(new Date().toLocaleString('en-US', { timeZone: 'Australia/Melbourne' }));
    // if (todayMorning && todayEvening) {
    if (melbSunset && melbSunrise) {
      (melbTime > melbSunrise && melbTime < melbSunset)
        // (new Date() > todayMorning && new Date() < todayEvening)
        ? setTheme('light')
        // : (melbTime < todayMorning || melbTime >= todayEvening)
        : (melbTime < melbSunrise || melbTime >= melbSunset)
          ? setTheme('dark') : setTheme('dark')
    }
  }, [melbSunset, melbSunrise, yesterdayEvening, setTheme]);

  return (
    <ThemeContext.Provider
      value={{
        name: theme,
        updateTheme: setTheme,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};
